import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/svg/cloud/cloud-2.svg'
import _imports_1 from '@/assets/svg/cloud/connect-cloud.svg'
import _imports_2 from '@/assets/svg/simpleJoin/scheme-m-l.svg'
import _imports_3 from '@/assets/svg/simpleJoin/scheme-s.svg'
import _imports_4 from '@/assets/svg/simpleJoin/block-1.svg'
import _imports_5 from '@/assets/svg/simpleJoin/block-1-s.svg'
import _imports_6 from '@/assets/svg/simpleJoin/block-2.svg'
import _imports_7 from '@/assets/svg/check.svg'
import _imports_8 from '@/assets/svg/simpleJoin/block-3.svg'
import _imports_9 from '@/assets/svg/simpleJoin/block-4.svg'


const _hoisted_1 = {
  class: "connect-wrapper mb-5",
  id: "join"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<img class=\"connect-cloud-left-top\" src=\"" + _imports_0 + "\"><img class=\"connect-cloud-right-bottom\" src=\"" + _imports_0 + "\"><img class=\"connect-cloud-right-top\" src=\"" + _imports_1 + "\"><img class=\"connect-cloud-left-bottom\" src=\"" + _imports_1 + "\"><div class=\"d-flex justify-content-center\"><div class=\"mx-4\"><div class=\"caps-text\">Обеспечиваем простой</div><div class=\"caps-text\">процесс подключения:</div><div class=\"connect__text size-m mt-3 text-center\">Выполним все необходимые работы за вас</div></div></div><div class=\"d-flex justify-content-center mt-4\"><img class=\"img-connect-scheme-m-l\" src=\"" + _imports_2 + "\"><img class=\"img-connect-scheme-s\" src=\"" + _imports_3 + "\"></div>", 6)
const _hoisted_8 = { class: "d-flex justify-content-center" }
const _hoisted_9 = { class: "connect-blocks-wrapper" }
const _hoisted_10 = { class: "connect-block b-1" }
const _hoisted_11 = { class: "text-wrapper" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "connect__text-bold" }, "Бесплатный и подробный аудит", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "connect__text size-m mt-2 mb-3 container-l" }, "Подберем по итогам аудита тот продукт, который соответствует потребностям вашего бизнеса и гарантированно решит вашу проблему", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "connect__text size-m mt-2 mb-3 container-s-m text-center" }, "Подберем по итогам аудита тот продукт, который соответствует потребностям вашего бизнеса и гарантированно решит вашу проблему", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("(function(w,d,u){ var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0); var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);})(window,document,'https://b24.vti-service.ru/upload/crm/form/loader_29_21faxn.js');")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Получить бесплатный аудит")
const _hoisted_17 = { class: "d-flex justify-content-center" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("(function(w,d,u){ var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0); var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);})(window,document,'https://b24.vti-service.ru/upload/crm/form/loader_29_21faxn.js');")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Получить бесплатный аудит")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  class: "container-l",
  src: _imports_4
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  class: "container-s-m",
  src: _imports_5
}, null, -1)
const _hoisted_22 = { class: "connect-block b-2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1)
const _hoisted_24 = { class: "text-wrapper" }
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"connect__text-bold\">Зарегистрируем вашу кассу в налоговой</div><div class=\"connect__text size-m text-center my-3\">При наличии электронной подписи, мы:</div><div class=\"my-3\"><div class=\"d-flex align-items-center my-2\"><div class=\"connect__text-number me-4\">01</div><div class=\"d-flex flex-column\"><div class=\"connect__text size-s\">Зарегистрируем кассу в налоговой</div><div class=\"connect__text size-s bold\">в течении одного дня</div></div></div><div class=\"d-flex align-items-center my-2\"><div class=\"connect__text-number me-3\">02</div><div class=\"connect__text size-s\">Подберем для вас фискальный накопитель</div></div><div class=\"d-flex align-items-center my-2\"><div class=\"connect__text-number me-3\">03</div><div class=\"connect__text size-s bold\">Подключим к ОФД и системе «Честный знак»</div></div></div>", 3)
const _hoisted_28 = /*#__PURE__*/_createTextVNode("(function(w,d,u){var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0); var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);})(window,document,'https://b24.vti-service.ru/upload/crm/form/loader_30_tblqxi.js');")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Консультация специалиста")
const _hoisted_30 = { class: "d-flex justify-content-center" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("(function(w,d,u){var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0); var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);})(window,document,'https://b24.vti-service.ru/upload/crm/form/loader_30_tblqxi.js');")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Консультация специалиста")
const _hoisted_33 = { class: "connect-block b-3" }
const _hoisted_34 = { class: "text-wrapper" }
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<div class=\"connect__text-bold\">Доступны разнообразные формы оплаты </div><div class=\"my-3\"><div class=\"d-flex align-items-start my-2\"><img class=\"me-2\" src=\"" + _imports_7 + "\"><div class=\"connect__text size-s\">Перейти по ссылке, отправленной в любом удобном канале коммуникации </div></div><div class=\"d-flex align-items-start my-2\"><img class=\"me-2\" src=\"" + _imports_7 + "\"><div class=\"connect__text size-s\">Сканировать qr-код для оплаты </div></div><div class=\"d-flex align-items-start my-2\"><img class=\"me-2\" src=\"" + _imports_7 + "\"><div class=\"connect__text size-s\">Можно встроить форму оплаты на сайт, которая будет предоставляться сразу после решения о покупке </div></div></div>", 2)
const _hoisted_37 = /*#__PURE__*/_createTextVNode("(function(w,d,u){ var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0); var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);})(window,document,'https://b24.vti-service.ru/upload/crm/form/loader_31_rymumh.js');")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Подробная информация об онлайн-кассе")
const _hoisted_39 = { class: "d-flex justify-content-center" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("(function(w,d,u){ var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0); var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);})(window,document,'https://b24.vti-service.ru/upload/crm/form/loader_31_rymumh.js');")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Подробная информация об онлайн-кассе")
const _hoisted_42 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-block-3",
  src: _imports_8
}, null, -1)
const _hoisted_43 = { class: "connect-block b-4" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("img", { src: _imports_9 }, null, -1)
const _hoisted_45 = { class: "text-wrapper" }
const _hoisted_46 = /*#__PURE__*/_createStaticVNode("<div class=\"connect__text-bold\">Настроим <span class=\"color-gradient\">VDCLOUD</span> под банк, в котором вы обслуживаетесь</div><div class=\"text-center\"><div class=\"connect__text size-m mt-2 mb-3\">Деньги будут поступать на тот счет, который вы укажете</div><div class=\"connect__text size-m bold mb-3\">Мы работаем с большинством крупных банков</div></div>", 2)
const _hoisted_48 = /*#__PURE__*/_createTextVNode("(function(w,d,u){ var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0); var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);})(window,document,'https://b24.vti-service.ru/upload/crm/form/loader_32_1r8fjh.js');")
const _hoisted_49 = /*#__PURE__*/_createTextVNode("Проверить совместимость с банком")
const _hoisted_50 = { class: "d-flex justify-content-center" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode("(function(w,d,u){ var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0); var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);})(window,document,'https://b24.vti-service.ru/upload/crm/form/loader_32_1r8fjh.js');")
const _hoisted_52 = /*#__PURE__*/_createTextVNode("Проверить совместимость с банком")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _hoisted_13,
            _hoisted_14,
            (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
              "data-b24-form": "click/29/21faxn",
              "data-skip-moving": "true"
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            })),
            _createVNode(_component_Button, {
              class: "container-l",
              size: "medium"
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_17, [
              (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
                "data-b24-form": "click/29/21faxn",
                "data-skip-moving": "true"
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              })),
              _createVNode(_component_Button, {
                class: "container-s-m",
                size: "xs"
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_20,
          _hoisted_21
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
              "data-b24-form": "click/30/tblqxi",
              "data-skip-moving": "true"
            }, {
              default: _withCtx(() => [
                _hoisted_28
              ]),
              _: 1
            })),
            _createVNode(_component_Button, {
              class: "container-l",
              size: "medium"
            }, {
              default: _withCtx(() => [
                _hoisted_29
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_30, [
              (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
                "data-b24-form": "click/30/tblqxi",
                "data-skip-moving": "true"
              }, {
                default: _withCtx(() => [
                  _hoisted_31
                ]),
                _: 1
              })),
              _createVNode(_component_Button, {
                class: "container-s-m",
                size: "xs"
              }, {
                default: _withCtx(() => [
                  _hoisted_32
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
              "data-b24-form": "click/31/rymumh",
              "data-skip-moving": "true"
            }, {
              default: _withCtx(() => [
                _hoisted_37
              ]),
              _: 1
            })),
            _createVNode(_component_Button, {
              class: "container-l",
              size: "medium"
            }, {
              default: _withCtx(() => [
                _hoisted_38
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_39, [
              (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
                "data-b24-form": "click/31/rymumh",
                "data-skip-moving": "true"
              }, {
                default: _withCtx(() => [
                  _hoisted_40
                ]),
                _: 1
              })),
              _createVNode(_component_Button, {
                class: "container-s-m",
                size: "xs"
              }, {
                default: _withCtx(() => [
                  _hoisted_41
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_42
        ]),
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createElementVNode("div", _hoisted_45, [
            _hoisted_46,
            (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
              "data-b24-form": "click/32/1r8fjh",
              "data-skip-moving": "true"
            }, {
              default: _withCtx(() => [
                _hoisted_48
              ]),
              _: 1
            })),
            _createVNode(_component_Button, {
              class: "container-l",
              size: "medium"
            }, {
              default: _withCtx(() => [
                _hoisted_49
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_50, [
              (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
                "data-b24-form": "click/32/1r8fjh",
                "data-skip-moving": "true"
              }, {
                default: _withCtx(() => [
                  _hoisted_51
                ]),
                _: 1
              })),
              _createVNode(_component_Button, {
                class: "container-s-m",
                size: "xs"
              }, {
                default: _withCtx(() => [
                  _hoisted_52
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}